var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FsLightbox',{key:_vm.productIndex,attrs:{"toggler":_vm.toggler,"sources":_vm.productsImages[_vm.productIndex]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }